'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
export default class Footer extends Component {
  render() {
    const footerClassNames = this.props.isFixed ? "fixed" : "";
    return /*#__PURE__*/_jsx("footer", {
      className: footerClassNames,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        align: "center",
        className: "wsg-container",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(UILink, {
            href: "https://legal.hubspot.com/privacy-policy",
            use: "on-dark",
            className: "m-right-2",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "footer.privacyPolicy"
            })
          }), "|", /*#__PURE__*/_jsx(UILink, {
            href: "https://legal.hubspot.com/legal-stuff",
            use: "on-dark",
            className: "m-left-2",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "footer.legalStuff"
            })
          })]
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "footer.poweredBy",
          className: "m-top-2"
        })]
      })
    });
  }

}
Footer.propTypes = {
  isFixed: PropTypes.bool
};